import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const toLocalDatetimeInput = (date) => {
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

const UnixTimestampConverter = () => {
  useDocumentMeta({
    title: 'Conversor de Unix Timestamp | jarder.dev',
    description:
      'Converta epoch/Unix timestamp para data legível e vice-versa. ' +
      'Grátis, direto no navegador.',
  })

  const [timestamp, setTimestamp] = useState(String(Math.floor(Date.now() / 1000)))
  const [datetime, setDatetime] = useState(toLocalDatetimeInput(new Date()))

  const fromTimestamp = () => {
    const num = Number(timestamp)
    if (Number.isNaN(num)) return
    const ms = timestamp.length > 10 ? num : num * 1000
    setDatetime(toLocalDatetimeInput(new Date(ms)))
    trackEvent('tool_generate', { tool: 'unix_timestamp', direction: 'to_date' })
  }

  const fromDatetime = () => {
    const date = new Date(datetime)
    if (Number.isNaN(date.getTime())) return
    setTimestamp(String(Math.floor(date.getTime() / 1000)))
    trackEvent('tool_generate', { tool: 'unix_timestamp', direction: 'to_epoch' })
  }

  const useNow = () => {
    const now = new Date()
    setTimestamp(String(Math.floor(now.getTime() / 1000)))
    setDatetime(toLocalDatetimeInput(now))
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Conversor de Unix Timestamp</h1>
      <p className="tool-disclaimer">
        Aceita timestamp em segundos ou milissegundos (detecta pelo
        tamanho do número).
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="timestamp">Timestamp (epoch)</label>
          <input
            id="timestamp"
            type="text"
            inputMode="numeric"
            value={timestamp}
            onChange={(e) => setTimestamp(e.target.value)}
          />
          <button type="button" className="tool-button tool-button-secondary" onClick={fromTimestamp}>
            Converter para data
          </button>
        </div>
        <div className="tool-field">
          <label htmlFor="datetime">Data e hora (local)</label>
          <input
            id="datetime"
            type="datetime-local"
            step="1"
            value={datetime}
            onChange={(e) => setDatetime(e.target.value)}
          />
          <button type="button" className="tool-button tool-button-secondary" onClick={fromDatetime}>
            Converter para timestamp
          </button>
        </div>
      </div>

      <button type="button" className="tool-button" onClick={useNow}>
        Usar agora
      </button>

      <div className="tool-info-section">
        <h2>O que é Unix timestamp</h2>
        <p>
          É a contagem de segundos (ou milissegundos) passados desde 1º
          de janeiro de 1970 às 00:00 UTC (o "epoch")  um jeito compacto
          e sem ambiguidade de fuso horário para armazenar datas em
          bancos de dados, logs e APIs. A ferramenta detecta
          automaticamente se o número está em segundos ou milissegundos
          pelo tamanho dele, e converte usando o fuso horário local do
          seu navegador.
        </p>
      </div>
    </div>
  )
}

export default UnixTimestampConverter
